/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RoutesRoutes {
  ROUTE_ASSIGN_PRIVACY_WARNING = '/aviso-de-privacidade/:nrSeqPrivacy',
  ROUTE_ASSIGN_TERM_USE = '/termo-de-uso/:nrSeqTerm',
  ROUTE_MY_DATA = '/meus-dados',
  ROUTE_PRIVACY = '/privacidade',
  ROUTE_TECHNICAL_VISIT = '/visita-tecnica',
  ROUTE_TECHNICAL_VISIT_DETAILS = '/visita-tecnica/detalhe/:nrSeqVisit',
  ROUTE_TECHNICAL_VISIT_FORMS = '/visita-tecnica/detalhe/:nrSeqVisit/formulario/:nrSeqForm',
}
export { RoutesRoutes };
